import { capitalize } from "lodash";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { slideDetailLabel } from "shared/utils/slideUtils";

import AdminLayout from "components/admin/AdminLayout";
import CasesTable from "components/admin/casesTable/CasesTable";
import FilterableDocumentsTable from "components/admin/documentsTable/FilterableDocumentsTable";
import FilterableOrdersTable from "components/admin/ordersTable/FilterableOrdersTable";
import FilterableSlidesTable from "components/admin/SlidesTable/FilterableSlidesTable";
import ApplicationState from "store/ApplicationState";

const AdminPage = ({
  list,
}: {
  list: "cases" | "orders" | "slides" | "documents";
}) => {
  const adminSlide = useSelector(({ admin }: ApplicationState) => admin.slide);
  const slide_id = parseInt(useParams<{ slide_id: string }>().slide_id || "0");

  return (
    <AdminLayout
      navLinks={[
        {
          label: "Cases",
          id: "cases",
          link: "/admin/cases",
        },
        {
          label: "Slides",
          id: "slides",
          link: "/admin/slides",
        },
        {
          label: "Orders",
          id: "orders",
          link: "/admin/orders",
        },
        {
          label: "Documents",
          id: "documents",
          link: "/admin/documents",
        },
      ]}
      selectedLink={list}
    >
      <>
        <Helmet>
          <title>
            QC Admin
            {slide_id && adminSlide && !adminSlide.isLoading
              ? ` - Slide ${
                  adminSlide.accession_number || "- Missing Case -"
                } ${slideDetailLabel(adminSlide)}`
              : ` - ${capitalize(list)} - Pathology Watch`}
          </title>
        </Helmet>
        <div className="AdminList">
          {list === "cases" && <CasesTable />}
          {list === "documents" && <FilterableDocumentsTable />}
          {list === "orders" && <FilterableOrdersTable />}
          {list === "slides" && <FilterableSlidesTable />}
        </div>
      </>
    </AdminLayout>
  );
};

export default AdminPage;
